import React, { useState } from "react";

import { UserPageContext } from "../contexts/userPageContext";

const UserPageContextProvider = ({ children }) => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState();
  const [totalPages, setTotalPages] = useState();
  const [users, setUsers] = useState();

  return (
    <UserPageContext.Provider
      value={{
        users,
        setUsers,
        currentPage,
        setCurrentPage,
        totalPages,
        setTotalPages,
        totalRecords,
        setTotalRecords,
        pageSize,
        setPageSize,
      }}
    >
      {children}
    </UserPageContext.Provider>
  );
};

export default UserPageContextProvider;
